<div class="lds-ellipsis" class="{{color? color : '$primary'}}">
  <div></div>
  <div></div>
  <div></div>
  <div></div>
</div>
